import { LoggerOptions } from './logger-options.service';

export {
  LoggerOptionsService,
  LoggerOptions,
  loggerOptionsFactory,
} from './logger-options.service';

export abstract class Logger {
  public abstract error(
    error: Error | string,
    properties?: { [name: string]: string | undefined | null },
    options?: LoggerOptions,
  ): void;
  public abstract info(
    message: string,
    properties?: { [name: string]: string | undefined | null },
    options?: LoggerOptions,
  ): void;
  public abstract warning(
    message: string,
    properties?: { [name: string]: string | undefined | null },
    options?: LoggerOptions,
  ): void;
}
